import { MouseEvent, useState } from 'react';
import { ContentLocation, Popover, PopoverState } from 'react-tiny-popover';

import { BpStatusButton, BpStatusPopover } from './components';
import { IBpStatusProps } from './types';

export const BpStatus = (props: IBpStatusProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOnClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  const handleContentLocation = (state: PopoverState): ContentLocation => {
    const left = state.childRect.x + state.childRect.width - state.popoverRect.width;
    const top = Math.abs(state.boundaryRect.y) + state.childRect.y;
    if (window.innerHeight - state.childRect.y > state.popoverRect.height) {
      return {
        left,
        top,
      };
    }

    return {
      left,
      top: top + state.childRect.height - state.popoverRect.height,
    };
  };

  if (props.disabled) {
    return <BpStatusButton {...props} />;
  }

  return (
    <Popover
      align="end"
      isOpen={isPopoverOpen}
      onClickOutside={handleClose}
      contentLocation={handleContentLocation}
      content={<BpStatusPopover {...props} onClose={handleClose} />}
    >
      <BpStatusButton {...props} status={props.patient.bloodPressure.status} onClick={handleOnClick} />
    </Popover>
  );
};
